"use client";

import { c as _c } from "react/compiler-runtime";
import { FilterLines, X } from "@untitledui/icons";
import { Button } from "@/components/base/buttons/button";
import { cx } from "@/utils/cx";
export type PoolsEmptyVariant = "filters" | "no-filters" | "favorites-search" | "favorites-none";
export function getPoolsEmptyCopy(variant: PoolsEmptyVariant): {
  title: string;
  body: string;
} {
  switch (variant) {
    case "filters":
      return {
        title: "No pools match your filters",
        body: "Try widening the TVL or volume range, or clear the filters to see everything."
      };
    case "favorites-search":
      return {
        title: "No favorites match your search",
        body: "Check the token symbol or address."
      };
    case "favorites-none":
      return {
        title: "No favorites yet",
        body: "Star a pool in the table to track it here."
      };
    default:
      return {
        title: "No pools found",
        body: "Pools will appear here once the catalog loads."
      };
  }
}
export function resolvePoolsEmptyVariant(args: {
  hideFilters: boolean;
  favoritesSearch: string;
  hasActiveFilters: boolean;
}): PoolsEmptyVariant {
  if (args.hideFilters) return args.favoritesSearch ? "favorites-search" : "favorites-none";
  return args.hasActiveFilters ? "filters" : "no-filters";
}
interface PoolsEmptyStateProps {
  variant: PoolsEmptyVariant;
  onClearFilters?: () => void;
  className?: string;
}
export function PoolsEmptyState(t0) {
  const $ = _c(19);
  const {
    variant,
    onClearFilters,
    className
  } = t0;
  let t1;
  if ($[0] !== variant) {
    t1 = getPoolsEmptyCopy(variant);
    $[0] = variant;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    title,
    body
  } = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cx("flex flex-col items-center justify-center gap-3 px-6 py-10 text-center", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="flex size-10 items-center justify-center rounded-full bg-secondary text-text-tertiary"><FilterLines className="size-5" aria-hidden="true" /></span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== title) {
    t4 = <p className="text-sm font-semibold text-text-primary">{title}</p>;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== body) {
    t5 = <p className="text-sm text-text-tertiary">{body}</p>;
    $[7] = body;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="space-y-1">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== onClearFilters || $[13] !== variant) {
    t7 = variant === "filters" && onClearFilters ? <Button color="secondary" size="sm" iconLeading={X} onClick={onClearFilters}>Clear filters</Button> : null;
    $[12] = onClearFilters;
    $[13] = variant;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t2 || $[16] !== t6 || $[17] !== t7) {
    t8 = <div role="status" className={t2}>{t3}{t6}{t7}</div>;
    $[15] = t2;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}